import { Component, ElementRef, Input, TemplateRef, ViewChild } from '@angular/core';

import { ModalRef } from '@ridango/components';
import { ModalService } from '@ridango/components/lib/core-ui';

@Component({
    selector: 'ridango-trip-message',
    templateUrl: './trip-message.component.html',
})
export class TripMessageComponent {
    @Input() messages = [];
    @Input() locale = 'en';

    private tripMessagesModal: ModalRef;

    @ViewChild('modalLink') modalLinkEl: ElementRef;
    @ViewChild('modalFocus') modalFocusEl: ElementRef;
    @ViewChild('modal', { read: TemplateRef, static: true }) modalRef: TemplateRef<any>;

    constructor(private modalService: ModalService) {}

    showModal() {
        this.tripMessagesModal = this.modalService.open(this.modalRef);
        setTimeout(() => this.modalFocusEl.nativeElement.focus());
    }

    closeModal() {
        this.tripMessagesModal.close();
        this.modalLinkEl.nativeElement.focus();
    }
}
